






import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "TipIcon",
  props: {
    fontSize: { type: [String, Number], default: 13 },
  },
  setup(props) {
    const style = computed(() => {
      return "font-size: " + (typeof props.fontSize === "number" ? props.fontSize + "px" : props.fontSize);
    });
    return { style };
  },
});
